import React from 'react';
import PropTypes from 'prop-types';
import util from "../../../../../../utils/es5Utils";
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const TableView  = function(props){
    if (!props.setRestBlockError) return null;
    const widgets = util.widgetsOfType(props.context, "tableview");
    const newProps = { ...props, widgets };
    const childBlocks = _.map(props.blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent { ...newProps } setRestBlockError = {props.setRestBlockError} key={blockKey}/>
    ));
            
    if (childBlocks.length > 0) {
        return (
            <category name='Table' id='tableview' iconclass='category with-icon-paths snap-icon-table_dual'>{/* NOSONAR */}
                <label text={"Table"}/>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

TableView.propTypes = {
    setRestBlockError: PropTypes.func,
    context: PropTypes.object,
    blocks: PropTypes.object
};

export default TableView;
